__turbopack_context__.v({
  "background": "style-module-scss-module__IDLcOG__background",
  "bottomContainer": "style-module-scss-module__IDLcOG__bottomContainer",
  "breadcrumbs": "style-module-scss-module__IDLcOG__breadcrumbs",
  "breadcrumbsWrap": "style-module-scss-module__IDLcOG__breadcrumbsWrap",
  "content": "style-module-scss-module__IDLcOG__content",
  "description": "style-module-scss-module__IDLcOG__description",
  "sliderWrapper": "style-module-scss-module__IDLcOG__sliderWrapper",
  "subtitle": "style-module-scss-module__IDLcOG__subtitle",
  "title": "style-module-scss-module__IDLcOG__title",
  "video": "style-module-scss-module__IDLcOG__video",
  "withoutFilter": "style-module-scss-module__IDLcOG__withoutFilter",
  "wrapper": "style-module-scss-module__IDLcOG__wrapper",
});
